/* istanbul ignore file */
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useFinanceUrl } from 'domain/people/employee/finance/financeRouting';

const EditFinanceButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useFinanceUrl();
  return <EditButton path={getUpdateEntityUrl} {...props} />;
};

export default EditFinanceButton;
